module.exports = __webpack_public_path__ + "fonts/GothamSSm-BookItalic.eb48ed73.woff2";